import { talukaUpdateApi } from "../../api/taluka/talukaUpdateApi"

type PayloadShape = Parameters<typeof talukaUpdateApi>[0]

export async function talukaUpdateService(payload: PayloadShape, token: string) {
	return await talukaUpdateApi(payload, token)
}
